/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
var globalVideoPlaying = false;

(function (a) {
  a.fn.prepareTransition = function () {
    return this.each(function () {
      var b = a(this);
      b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
        b.removeClass("is-transitioning")
      });
      var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
      var d = 0;
      a.each(c, function (a, c) {
        d = parseFloat(b.css(c)) || d
      });
      if (d != 0) {
        b.addClass("is-transitioning");
        b[0].offsetWidth
      }
    })
  }
})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e, r, a) {
  var n = new RegExp("(" + r + "=).*?(&|$)"), c = e;
  return c = e.search(n) >= 0 ? e.replace(n, "$1" + a + "$2") : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a
};

/*============================================================================
 Money Format
 - Shopify.format money is defined in option_selection.js.
 If that file is not included, it is redefined here.
 ==============================================================================*/
if ((typeof Shopify) === 'undefined') {
  Shopify = {};
}
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function (cents, format) {
    var value = '',
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $(document.body),

    // Navigation
    $navigation: $('#AccessibleNav'),
    $mobileSubNavToggle: $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView: $('.change-view'),

    // Product Page
    $productImage: $('#ProductPhotoImg'),
    $thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink: $('#RecoverPassword'),
    $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
    $recoverPasswordForm: $('#RecoverPasswordForm'),
    $customerLoginForm: $('#CustomerLoginForm'),
    $passwordResetSuccess: $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.disclosuresInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
  //social.init();
  timber.productDescription();
  timber.cookies();
  timber.apiFetch();

  timber.readmore();
  objectFitImages();

  if (!timber.readCookie('debug-zoofamily-newsletter')) {
    $('.popup-newsletter-trigger').trigger('click');
    timber.createCookie('debug-zoofamily-newsletter', 'popup', 300);
  }







  var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy"
  });

  timber.slick();

 // timber.paddingMain();

  if ($('.js-scroll-to').length > 0) {
    $('.js-scroll-to').each(function(){
      var scroll_target = $(this).attr('href');
      if ($(scroll_target).length == 0) {
        $(this).hide();
      }
    })
  }

  $('.js-scroll-to').on('click', function () {
    var target = $(this).attr('href');
    
    $('html, body').animate({
        scrollTop: $(target).offset().top
    }, 2000);
  });

};

timber.disclosuresInit = function() {
  timber.DisclosureEls = new timber.Disclosures();
}

timber.readmore = function () {
  $('.readmore__trigger').on('click', function (e) {
    var $el = $(e.currentTarget);
    $el.parent().toggleClass('active');
  });
}
/*============================================================================
  Disclosure modules
  - Source https://gist.github.com/benkovy/af523d2604560546b02494a9379a53be
==============================================================================*/
timber.Disclosures = (function() {
  var selectors = {
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  var Disclosure = function () {
    this.$container = $('.disclosure');
    this.cache = {};
    this.cacheSelectors();
    this.connectOptions();
    this.connectToggle();
    this.onFocusOut();
  };

  Disclosure.prototype.cacheSelectors = function() {
    this.cache = {
      $disclosureList: this.$container.find(selectors.disclosureList),
      $disclosureToggle: this.$container.find(selectors.disclosureToggle),
      $disclosureInput: this.$container.find(selectors.disclosureInput),
      $disclosureOptions: this.$container.find(selectors.disclosureOptions)
    };
  },

    Disclosure.prototype.connectToggle = function() {
      this.cache.$disclosureToggle.on(
        'click',
        function(evt) {
          var ariaExpanded =
            $(evt.currentTarget).attr('aria-expanded') === 'true';
          $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

          this.cache.$disclosureList.toggleClass(classes.listVisible);
        }.bind(this)
      );
    },

    Disclosure.prototype.connectOptions = function() {
      this.cache.$disclosureOptions.on(
        'click',
        function(evt) {
          evt.preventDefault();
          this.submitForm($(evt.currentTarget).data('value'));
        }.bind(this)
      );
    },

    Disclosure.prototype.onFocusOut = function() {
      this.cache.$disclosureToggle.on(
        'focusout',
        function(evt) {
          var disclosureLostFocus =
            this.$container.has(evt.relatedTarget).length === 0;

          if (disclosureLostFocus) {
            this.hideList();
          }
        }.bind(this)
      );

      this.cache.$disclosureList.on(
        'focusout',
        function(evt) {
          var childInFocus =
            $(evt.currentTarget).has(evt.relatedTarget).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !childInFocus) {
            this.hideList();
          }
        }.bind(this)
      );

      this.$container.on(
        'keyup',
        function(evt) {
          // escape
          if (evt.which !== 27) return;
          this.hideList();
          this.cache.$disclosureToggle.focus();
        }.bind(this)
      );

      $('body').on(
        'click',
        function(evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !isOption) {
            this.hideList();
          }
        }.bind(this)
      );
    },

    Disclosure.prototype.submitForm = function(value) {
      console.log(value);
      this.cache.$disclosureInput.val(value);
      this.$container.parents('form').submit();
    },

    Disclosure.prototype.hideList = function() {
      this.cache.$disclosureList.removeClass(classes.listVisible);
      this.cache.$disclosureToggle.attr('aria-expanded', false);
    },

    Disclosure.prototype.unload = function() {
      this.cache.$disclosureOptions.off();
      this.cache.$disclosureToggle.off();
      this.cache.$disclosureList.off();
      this.$container.off();
    }

  return Disclosure;
})();

timber.cookies = function () {
  if (timber.readCookie('debug-zoofamily-cookies')) {
    $('.cookie-notification ').addClass('accepted');
  } else {
    $('.cookie-notification ').removeClass('accepted');
  }

  $('#accept-cookies').on('click', function () {
    $('.cookie-notification ').addClass('accepted');
    timber.createCookie('debug-zoofamily-cookies', 'popup', 300);
  });
}

timber.productDescription = function () {
    if($('.product-description ul').length) {

      $('.product-description ul').before($('#ProductSubtitleInfo'));
    }

  $('.popup-trigger').modaal({
    type: 'inline',

    before_open: function (e) {
      var $el = $(e.currentTarget);
      globalVideoPlaying = $('.popup video')[0];
      if(globalVideoPlaying) {
        globalVideoPlaying.play();
      }

      $('body').removeClass('loading');
      var el = $(e.currentTarget);
      var $closeButton = $('.btn--close-modal')
      $closeButton.unbind('click');
      $closeButton.on('click', function () {
        $(el).modaal('close');
      });
    },
  after_close: function ()  {
    if(globalVideoPlaying) {
    globalVideoPlaying.pause();
    }
  }
  });
  /*
  $('.popup-newsletter-trigger').modaal({
    type: 'inline',
    custom_class:'popup-newsletter',

    before_open: function (e) {
      var $el = $(e.currentTarget);

      $('body').removeClass('loading');
      var el = $(e.currentTarget);
      var $closeButton = $('.btn--close-modal')
      $closeButton.unbind('click');
      $closeButton.on('click', function () {
        $(el).modaal('close');
      });
    },
  });
  $('.popup-newsletter-confirm-trigger').modaal({
    type: 'inline',
    custom_class:'popup-newsletter',

    before_open: function (e) {
      var $el = $(e.currentTarget);

      $('body').removeClass('loading');
      var el = $(e.currentTarget);
      var $closeButton = $('.btn--close-modal')
      $closeButton.unbind('click');
      $closeButton.on('click', function () {
        $(el).modaal('close');
      });
    },
  });*/

};

timber.paddingMain = function () {
  $('.main-content').css('padding-top', $('.site-header').height());
  if ($('body').hasClass('template-index') || $('body').attr('id') == 'over-ons') {
    $('.main-content').css('padding-top', $('.site-header').height());
  }
};



timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
    $allLinks = $nav.find('a'),
    $topLevel = $nav.children('li').find('a'),
    $parents = $nav.find('.site-nav--has-dropdown'),
    $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
    activeClass = 'nav-hover',
    focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function (evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function () {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function (evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function () {
    handleFocus($(this));
  });

  $allLinks.blur(function () {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus($el) {
    var $subMenu = $el.next('ul'),
      hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
      isSubItem = $('.site-nav__dropdown').has($el).length,
      $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown($el) {
    $el.addClass(activeClass);
    //var mt = $('.nav-hover').css('padding-bottom').split('px')[0]/2;
    //console.log(mt);
    //$('.main-content').css('margin-top', -mt);

    setTimeout(function () {
      timber.cache.$body.on('touchstart', function () {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    $el.removeClass(activeClass);
    // $('.main-content').css('margin-top', '');
    timber.cache.$body.off('touchstart');
  }

  function addFocus($el) {
    $el.addClass(focusClass);
  }

  function removeFocus($el) {
    $el.removeClass(focusClass);
  }
};

timber.slick = function () {

  var cmode = false;

  $('.slick-uspbar').slick({

    speed: 1000,
    infinte: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    navigation: false,
    mobileFirst: true,

    responsive: [

      {
        breakpoint: 480,
        settings: {

          slidesToShow: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
    ]
  })

// play and pause slick js start here //

  var slideWrapper = $(".product-main-slider"),
    iframes = slideWrapper.find('.embed-player'),
    lazyImages = slideWrapper.find('.slide-image'),
    lazyCounter = 0;
  
  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }
  
  // When the slide is changing
  function playPauseVideo(slick, control){
    var currentSlide, slideType, startTime, player, video;
  
      currentSlide = slick.find(".slick-current");
      slideType = currentSlide.attr("class").split(" ")[1];
      player = currentSlide.find("iframe").get(0);
      startTime = currentSlide.data("video-start");
  
    if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
            currentSlide.addClass('started');
            postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value" : startTime
            });
          }
          postMessageToPlayer(player, {
            "method": "play",
            "value" : 1
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          break;
      }
    } else if (slideType === "video-iframe") {
      switch (control) {
        case "play":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "mute"
          });
          postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "video") {      
      video = currentSlide.find("video").get(0);
      if (video != null) {
        if (control === "play"){
          video.play();
        } else {
          video.pause();
        }
      }
    }
  }
  
  // DOM Ready
  $(function() {
    // Initialize
    slideWrapper.on("init", function(slick){
      slick = $(slick.currentTarget);
      setTimeout(function(){
        playPauseVideo(slick,"play");
      }, 1000);
      //resizePlayer(iframes, 16/9);
    });
    slideWrapper.on("beforeChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"pause");
    });
    slideWrapper.on("afterChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"play");
    });
    slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
      lazyCounter++;
      if (lazyCounter === lazyImages.length){
        lazyImages.addClass('show');
        // slideWrapper.slick("slickPlay");
      }
    });
  
    //start the slider
   slideWrapper.slick({
      arrows: true,
      prevArrow: '<div class="slick-arrow slick-prev"><i class="icon-arrow"></i> <span class="vh">Vorige</span></div>',
      nextArrow: '<div class="slick-arrow slick-next"><i class="icon-arrow"></i> <span class="vh">Volgende</span></div>',
      dots:false,
      infinite:false,
      centerMode: false,
      slidesToShow: 1,  
      // adaptiveHeight: true,
      asNavFor: '.slick-center', 
      navigation: true,
      mobileFirst: true,    
      responsive: [
        {
          breakpoint: 576,
          settings: {
            dots:false,
            // arrows:true,
          }
        },
        {
          breakpoint: 319,
          settings: {
            dots:false,
            // arrows:false,
          }
        }
      ]
    });
  });  

// play and pause slick js end here //  
  
  if ($('.product-single__thumbnails .grid__item').length >= 4) {

    //cmode = true;

    $('.slick-cente').slick({
      centerMode: false,
      //centerPadding: '20px',
      mobileFirst:true,
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: false,
      prevArrow: '<div class="slick-arrow slick-prev"><i class="icon-arrow"></i> <span class="vh">Vorige</span></div>',
      nextArrow: '<div class="slick-arrow slick-next"><i class="icon-arrow"></i> <span class="vh">Volgende</span></div>',

      responsive: [
        {
          breakpoint: 768,
          settings: {
           // centerMode: true,
            centerPadding: '20px',
          }
        },
        {
          breakpoint: 1200,
          settings: {
           // centerMode: true,
            centerPadding: '20px',
            slidesToShow: 6,
            slidesToScroll: 6
          }
        },

      ]
    });
  } else {

  }

$('.slick-center').slick({    
  centerMode: false,  
  mobileFirst:true,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  prevArrow: '<div class="slick-arrow slick-prev"><i class="icon-arrow"></i> <span class="vh">Vorige</span></div>',
  nextArrow: '<div class="slick-arrow slick-next"><i class="icon-arrow"></i> <span class="vh">Volgende</span></div>',
  asNavFor: '.product-main-slider',
  focusOnSelect: true,
  responsive: [
     {
      breakpoint: 1200,
      settings: {
        // centerMode: true,
        centerPadding: '20px',
        slidesToShow: 4,
        // slidesToScroll: 4
      }
     },
    {
      breakpoint: 991,
      settings: {
        centerPadding: '20px',
         slidesToShow: 3,
        // slidesToScroll: 3
      }
    },
  ]   
});

};


timber.apiFetch = function () {
  var truncate = function (text) {
    if(text) {
      var string = text.substring(0, 120);
      if (text.length > 120) {
        string += '&hellip;'
      }

      return string;
    } else {
      return '';
    }
  };

  $('.js-api-fetch').each(function() {
    var $this = $(this);
    var element = this;
    console.log(element);
    
    var template = element.querySelector('.json-fetcher__template');
    var keys = element.dataset.keys.split(';');
    var api = $this.data('api');
    var limit = $this.data('limit'); // optional limitation
    var itemClass = $this.data('item-class');

  

    $.ajax({
      url: api,
      data: {},
      dataType: 'json',
      success: function(data) {
        console.log(data);
        data = timber.loopableObject(data);
        timber.parseResults(data, template, keys, element); 

      },
      error: function(err) {
        timber.printError(err);
      }
    });
  });
};
timber.parseResults = function (json, template,keys,element) {

    json.forEach(function(item) {
      const templateClone = template.cloneNode(true);
      keys.forEach(function(key) {
        try {
          const keyParts = key.split('.');
          let index = 0;
          let data = item;
          while (index + 1 <= keyParts.length) {
            data = data[keyParts[index]];
            index += 1;
          }
          templateClone.innerHTML = templateClone.innerHTML.replace('__'+ key + '__', data);
        } catch (error) {
          //printError(error);
        }
      });
      templateClone.innerHTML = templateClone.innerHTML.replace('data-src', 'src');
      element.appendChild(templateClone.children[0]);
    });
    template.parentNode.removeChild(template);
  
}
 timber.printError = function (error) {
    // eslint-disable-next-line no-console
    console.error(error.responseText);
  }
  timber.loopableObject = function (json) {
    return json.data ? json.data : json;
}

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
  timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': ajaxCart.load
  });
  
};

// Cart Remove Ajax call 
$(document).on('click', '.cart__remove-btn', function(e) {
  e.preventDefault();

  var $btn = $(this);
  var line = $btn.data('line');

  // Post request to Shopify cart change endpoint to set quantity to 0
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      line: line,
      quantity: 0
    },
    dataType: 'json',
    success: function(cart) {
      // Refresh your cart drawer here
      // Assuming you have a function to reload drawer contents (e.g. timber.RightDrawer.config.onDrawerOpen)
      if (timber.RightDrawer && timber.RightDrawer.config.onDrawerOpen) {
        timber.RightDrawer.config.onDrawerOpen();
      } else {
        // Or reload page or update drawer contents manually if no onDrawerOpen function
        location.reload(); // fallback — reload page if no ajax cart refresh
      }
    },
    error: function(xhr, status, error) {
      console.error('Failed to remove item:', error);
    }
  });
});

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function () {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
    variant = options.variant,
    selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
    $addToCart = $('#AddToCart'),
    $productPrice = $('#ProductPrice'),
    $comparePrice = $('#ComparePrice'),
    $quantityElements = $('.quantity-selector, label + .js-qty'),
    $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
        el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html('<i class="icomoon-cart" aria-hidden="true"></i> ' + "Add to Cart" );
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Compare at" +' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {  // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function (evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function () {
      var view = $(this).data('view'),
        url = document.URL,
        urlWithoutHash = url.split('#')[0],
        hasParams = url.indexOf('?') > -1,
        location = '';

      if (hasParams) {
        location = replaceUrlParam(urlWithoutHash, 'view', view);
      } else {
        location = urlWithoutHash + '?view=' + view;
      }

      if (url.indexOf('#') > -1) {
        var hash = url.substring(url.indexOf('#') + 1);
        location += '#' + hash;
      }

      window.location = location;
    });
  }
};

timber.loginForms = function () {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function (evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function () {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
 Drawer modules
 - Docs http://shopify.github.io/Timber/#drawers
 ==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({disableExisting: true});
    this.$drawer.prepareTransition({disableExisting: true});

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

timber.createCookie = function (name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
  }
  else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}

timber.readCookie = function (name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Initialize Timber's JS on docready
$(timber.init);

$(document).ready(function(){

    //****** Accodidan JS ******//
    $('.accodian-title').click(function () {
        $('.accodian-title').removeClass('active');
        $('.accodian-content-wrapper').slideUp();
        if (!$(this).next().is(':visible')) {
            $(this).next().slideDown();
            $(this).addClass('active');
        }
    });

    $.getJSON('/cart.js', function (cart, textStatus) {
        $('.cart-count').text(cart.item_count);
    });  

      $("body").on("click",".jdgm-revs-tab-btn",function(e){
        e.preventDefault();
        window.location.href = '/pages/reviews';
  });

  //  $("body").on("click", ".jdgm-revs-tab-btn", function(e) {
  //   e.preventDefault();

  //   // Get the current language from the URL
  //   var path = window.location.pathname;  // e.g., '/en/products/some-product'
  //   var currentLanguage = path.split('/')[1];  // Extract the language code (e.g., 'en')
    

  //   // Redirect to the reviews page while keeping the language part of the URL
  //   window.location.href = '/' + currentLanguage + '/pages/reviews';
  //   });



    $('.jdgm-prev-badge').click(function(){ 
        $('.review-title li[data-id="rev-1"]').trigger('click');  
    });


    //****** Header Menu Open-Close JS ******//
    
    $(".menu-mb-icon button").on("click", function () {
        $(".header_menu").addClass("open");
    });
    $(".header_menu .close-icon").on("click", function () {
        $(".header_menu").removeClass("open");
    });

    // function megaMenuAccordion() {
   if ($(window).width() < 992) {
    $('.header_menu .header_menu_list .menu_item_link').click(function (e) {
      // Check if submenu exists
      var submenu = $(this).next('.header_mega_menu, .sub_main_nav');
      
      if (submenu.length) {
        e.preventDefault(); // Only prevent if submenu exists
        $('.header_menu_item').removeClass('open');
        $('.header_menu_item .header_mega_menu, .header_menu_item .sub_main_nav').slideUp();
        if (!submenu.is(':visible')) {
          submenu.slideDown();
          $(this).parent('.header_menu_item').addClass('open');
        }
      } 
      // else: no submenu - let the link navigate as usual
    });
  
    $('.header_mega_menu .mega_menu_title h5').off('click').on('click', function (e) {
      e.preventDefault();
      $('.mega_menu_title').removeClass('open');
      $('.mega_menu_col .mega_menu_info').slideUp();
  
      if (!$(this).parent('.mega_menu_title').next('.mega_menu_info').is(':visible')) {
        $(this).parent('.mega_menu_title').next('.mega_menu_info').slideDown();
        $(this).parent('.mega_menu_title').addClass('open');
      }
    });
  }
        // else { 
        //     $('.mega_menu_col .mega_menu_info').removeAttr('style');
        //     $('.mega_menu_title').removeClass('open');
        //     $('.header_menu_item').removeClass('open');
        //     $('.header_menu_item .header_mega_menu, .header_menu_item .sub_main_nav').removeAttr('style');
        // }
    // }
    // megaMenuAccordion();
    // $(window).resize(function() {
    //     megaMenuAccordion();
    // });

    // Header Sticky Js
    function headerspace() {
      var headerHeight = $('header.main-header-section').outerHeight();
      var black_friday_banner = $('.black-friday-banner').outerHeight();
      var totalHeight = headerHeight + black_friday_banner
      $('main.main-content').attr("style", "padding-top: " + totalHeight + "px !important");
	  }
	  headerspace();
	  $(window).on('resize load scroll orientationchange', function () {
  		headerspace();
  	});
});



 if (window.location.search.includes('contact_posted=true')) {
    // Scroll to the success message
    window.scrollTo({
      top: document.getElementById("contact-success-message").offsetTop,
      behavior: "smooth"
    });
  }


document.addEventListener("DOMContentLoaded", () => {
  function black_friday_banner() {
    const BFriday_banner = document.querySelector(".black-friday-banner");
    if (!BFriday_banner) return;
    const BFriday_bannerHeight = BFriday_banner.offsetHeight;
    document.querySelectorAll("div#shopify-section-new-header").forEach(el => {
      el.style.top = `${BFriday_bannerHeight}px`;
    });
  }
  black_friday_banner();
  ["resize", "load", "scroll", "orientationchange"].forEach(event => {
    window.addEventListener(event, black_friday_banner);
  });
});
